const initialStateCompetency = {
    competency: [],
    competency_update: false,
    competency_competency_category: [],
    competency_competency_category_update: false,
};

export default initialStateCompetency;